import React from "react";
import {Progress} from "reactstrap";
import {useSelector} from "react-redux";
import {getCloneProgress} from "../../../redux/Selectors/cloneProfile.selectors";

// Purely presentational: polling, toasts, and completion handling all live
// in CloneSensorsWatcher (mounted once at the app root) so they keep
// running whether or not this component — or the modal it's shown in —
// is even mounted. This just reflects whatever progress the watcher has
// last recorded in Redux.
const SensorCloningProgress = () => {
  const {current, total} = useSelector(getCloneProgress);
  const percent = total > 0 ? Math.round((current / total) * 100) : 0;

  return (
    <div className="py-3">
      <div className="d-flex justify-content-between mb-1">
        <small className="text-muted">Cloning sensors…</small>
        {total > 0 && (
          <small className="text-muted">
            {current} / {total}
          </small>
        )}
      </div>
      <Progress
        animated={total === 0}
        value={total === 0 ? 100 : percent}
        color="primary"
      />
    </div>
  );
};

export default SensorCloningProgress;
